/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SavedSearchController {
   $controller: any
   $location: any
   $scope: any
   alerts: any
   appState: any
   baseCtrl: any
   cloudStorage: any
   events: any
   i18n: any
   menuManagerService: any
   moreFacetsService: any
   savedSearch: any
   viewState: any
   constructor($controller: any, $scope: any, $location: any, cloudStorage: any, savedSearch: any, events: any, l10n: any, i18n: any, alerts: any, appState: any, viewState: any, menuManagerService: any, moreFacetsService: any) {
      this.setCurrentSearch = this.setCurrentSearch.bind(this)
      this.resetDialog = this.resetDialog.bind(this)
      this.getSavedSearches = this.getSavedSearches.bind(this)
      this.removeSearch = this.removeSearch.bind(this)
      this.runSearch = this.runSearch.bind(this)
      this.toggleSavedSearches = this.toggleSavedSearches.bind(this)
      this.$controller = $controller
      this.$scope = $scope
      this.$location = $location
      this.cloudStorage = cloudStorage
      this.savedSearch = savedSearch
      this.events = events
      this.i18n = i18n
      this.alerts = alerts
      this.appState = appState
      this.viewState = viewState
      this.menuManagerService = menuManagerService
      this.moreFacetsService = moreFacetsService

      // set scope functions
      this.$scope.runSearch = this.runSearch
      this.$scope.removeSearch = this.removeSearch
      this.$scope.toggleSavedSearches = this.toggleSavedSearches
      this.$scope.setCurrentSearch = this.setCurrentSearch
      this.$scope.getSavedSearches = this.getSavedSearches
      this.$scope.cancelEdit = this.savedSearch.resetCurrentSearch
      this.$scope.getFilterText = this.savedSearch.getFilterText
      this.$scope.removeAllSearches = this.savedSearch.removeAllSearches

      // instantiate base controller functionality on scope
      this.baseCtrl = this.$controller('SavedSearchAndItemsBaseCtrl', {$scope: this.$scope, cloudStorage: this.cloudStorage, savedSearch: this.savedSearch, events: this.events, i18n: this.i18n, alerts: this.alerts})
   }

   setCurrentSearch(searchItem: any, idx: any) {
      this.resetDialog()
      return this.savedSearch.setCurrentSearch(searchItem, idx)
   }

   resetDialog() {
      this.$scope.removeIndex = -1
      this.alerts.resetAlert('cloudStorageApiError')
      return this.savedSearch.resetCurrentSearch()
   }

   // used for savedSearchError retry functionality
   getSavedSearches() {
      this.alerts.resetAlert('savedSearchError')
      return this.savedSearch.getSavedSearches()
   }

   removeSearch(idx: any) {
      this.savedSearch.resetCurrentSearch()
      this.$scope.removeIndex = idx
      this.$scope.showSpinner = true
      this.$scope.spinnerAction = this.i18n.translations.REMOVING_THIS_ITEM
      return this.savedSearch.removeSearch(idx)
         .then((result: any) => {
            this.resetDialog()
            this.events.gaPush('saved search', 'removed', 'existing')
            return this.baseCtrl.hideSpinner()
         }).catch(this.baseCtrl.handleError)
   }

   runSearch(params: any) {
      this.viewState.currentView = 'search'
      this.$scope.resetNewSearchFlag()
      const setState = () => {
         this.appState.params = angular.copy(params)
         return this.events.gaPush('saved search', 'run', params.q)
      }
      return this.appState.applyStateWithSnapShot(setState)
   }

   toggleSavedSearches() {
      if (this.$location.path !== "/search") { this.$location.path("/search") }

      // clean-up menus
      this.menuManagerService.closeAllMenuTypeSubMenu()

      if (this.viewState.currentView === "savedSearches") {
         this.$scope.setWindowTitle(this.i18n.translations.RESULTS_FOR + `\"${this.$scope.search.query}\"`)
         this.$scope.savedSearch.visible = false
         this.viewState.currentView = "search"
         return this.events.publish("actions", "saved_searches:close")
      } else {
         this.$scope.setWindowTitle(this.i18n.translations.SAVED_SEARCHES)
         this.$scope.setRetainState(true)
         this.$scope.savedSearch.visible = true
         this.viewState.currentView = "savedSearches"
         return this.events.publish("actions", "saved_searches:open")
      }
   }
}

SavedSearchController.$inject = ['$controller', '$scope', '$location', 'cloudStorageService', 'savedSearchService', 'eventService', 'localizationService', 'translationService', 'alertService', 'appStateService', 'viewStateService', 'menuManagerService', 'moreFacetsService']

angular.module('summonApp.controllers')
   .controller('SavedSearchCtrl', SavedSearchController)
